import { ApiService } from 'js/src/client';
import {
    selectAllNotificationIds,
    setHasUnreadNotifications,
    setLoadingNotifications,
    setNotificationsAsRead,
    setNotificationsIsEmpty,
    storeNotifications,
} from 'js/src/data/notifications';
import { ImmutableFromJS } from 'js/src/libs/consts';
import { ErrorReporter } from 'js/src/libs/error-reporter';
import type { AppDispatch } from 'js/src/libs/RootState';
import type { GetRootState } from 'js/src/luminary/luminary-redux-connect-types';

export function loadNotifications() {
    return (dispatch: AppDispatch) => {
        return new Promise<boolean>((resolve, reject) => {
            ApiService.notificationsList()
                .then((response) => {
                    dispatch(
                        storeNotifications({
                            notifications_list: ImmutableFromJS(response.data),
                        }),
                    );
                    dispatch(
                        setNotificationsIsEmpty({
                            isEmpty: response.data.length === 0,
                        }),
                    );
                    resolve(true);
                })
                .catch((error: unknown) => {
                    ErrorReporter.capture(error);
                    reject(new Error('Something went wrong retrieving notifications'));
                })
                .finally(() => {
                    dispatch(setLoadingNotifications({ isLoading: false }));
                });
        });
    };
}

export function markNotificationAsRead(notification_id: number) {
    return (dispatch: AppDispatch) => {
        dispatch(setNotificationsAsRead({ notification_ids: [notification_id] }));
        return ApiService.notificationsMarkAsReadPartialUpdate({
            path: { id: notification_id },
        });
    };
}

export function markAllNotificationsAsRead() {
    return (dispatch: AppDispatch, getState: GetRootState) => {
        const notification_ids = selectAllNotificationIds(getState());
        dispatch(
            setNotificationsAsRead({
                notification_ids: notification_ids.toArray(),
            }),
        );
        return ApiService.notificationsMarkAllAsReadPartialUpdate();
    };
}

export function getHasUnreadNotifications() {
    return (dispatch: AppDispatch) => {
        return new Promise<boolean>((resolve, reject) => {
            ApiService.notificationsNumUnreadRetrieve()
                .then((response) => {
                    dispatch(
                        setHasUnreadNotifications({
                            hasUnread: response.data.count > 0,
                        }),
                    );
                    resolve(true);
                })
                .catch((error: unknown) => {
                    ErrorReporter.capture(error);
                    reject(new Error('Something went wrong retrieving notification read status'));
                });
        });
    };
}
